import { filterAdapter, ModuleState } from '../state';

export const selectSelectedFilters = (state: ModuleState) => state.selectedFilters;
export const selectFilters = (state: ModuleState) => state.filters;
///////////////////////////////////////////////////////////
export const selectedFiltersSelector = filterAdapter.getSelectors(selectSelectedFilters).selectAll;
export const filtersSelector = filterAdapter.getSelectors(selectFilters).selectAll;
